"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

var _installTask = require("@/api/cms/installTask");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ClockInRecord',
  props: {
    installTaskId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      recordList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  watch: {
    installTaskId: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.currentPage = 1;
          this.loadData();
        }
      }
    }
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      if (!this.installTaskId) return;
      this.loading = true;
      var params = {
        page: this.currentPage - 1,
        size: this.pageSize,
        installTaskId: this.installTaskId
      };
      (0, _installTask.getInstallTaskSigninLog)(params).then(function (response) {
        if (response.code === 200) {
          _this.recordList = response.data.content || [];
          _this.total = response.data.totalElements || 0;
        } else {
          _this.$message.error(response.msg || '加载打卡记录失败');
        }
      }).catch(function () {
        _this.$message.error('网络错误');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    getCategoryTagType: function getCategoryTagType(category) {
      if (!category) return 'info';
      if (category.includes('进场')) return 'success';
      if (category.includes('离场')) return 'warning';
      return 'info';
    }
  }
};
exports.default = _default;